import { useEffect, useState } from 'react';
import { uploadProgressBus } from './attachPasteDrop';

/** Percent of the create-ticket upload in flight (null when none). */
export function useUploadProgress(active: boolean): number | null {
  const [pct, setPct] = useState<number | null>(null);
  useEffect(() => {
    if (!active) { setPct(null); return undefined; }
    return uploadProgressBus.subscribe(setPct);
  }, [active]);
  return active ? pct : null;
}
